import { DatePipe as NgDatePipe } from '@angular/common';
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { LOCALE_DATE_FORMATS } from '../../i18n/i18n.config';
import { ILocaleDateFormats } from '../../i18n/i18n.types';

@Pipe({
  name: 'appDate'
})
export class DatePipe implements PipeTransform {
  constructor(
    private datePipe: NgDatePipe,
    @Inject(LOCALE_DATE_FORMATS) private dateFormats: ILocaleDateFormats,
  ) {}

  public transform(
    value: string | number | Date | null,
    format: string | undefined = this.dateFormats.shortDate,
    timezone?: string,
    locale?: string,
  ): ReturnType<NgDatePipe['transform']> {
    return this.datePipe.transform(
      value,
      this.dateFormats[format as keyof ILocaleDateFormats] || format,
      timezone,
      locale,
    );
  }
}
